module.exports = __webpack_public_path__ + "img/BS-PQ_original.9debcc9b.png";